import { render, staticRenderFns } from "./OurStories.vue?vue&type=template&id=e3a327e2&"
import script from "./OurStories.vue?vue&type=script&lang=js&"
export * from "./OurStories.vue?vue&type=script&lang=js&"
import style0 from "./OurStories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports